import { Link } from 'react-router-dom'
import { footerSections } from '../../constants'

const Footer = () => {
  const footerSectionsContent = footerSections.map((footerSection, index) => {
    return (
      <div key={`footer-${index}`} className="max-w-[216px] w-full">
        <h5 className="text-[#C37104] text-sm font-semibold">{footerSection.title}</h5>

        <ul className="mt-[16px] flex flex-col items-start gap-y-[12px]">
          {footerSection.links.map((link, linkIndex) => {
            return (
              <li key={`footer-${index}-${linkIndex}`} className="flex">
                <Link
                  to={link.link}
                  className="text-base text-primary-100 hover:text-primary-100 hover:underline font-normal"
                >
                  {link.label}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    )
  })

  return (
    <div className="w-full pt-[64px] pb-[48px] px-[24px] bg-[#FEEBDD] flex flex-col items-center justify-center">
      <div className="w-full gap-[32px] flex items-center justify-center flex-wrap">
        {footerSectionsContent}
      </div>

      <div className="flex flex-col items-center justify-center mt-[64px]">
        <img src="/assets/icon/footer-logo.svg" alt="Logo" width={180} height={48} />

        <p className="mt-[12px] text-base font-medium text-primary-100">
          © 2025 All rights reserved.
        </p>
      </div>
    </div>
  )
}

export default Footer
